import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import FeatureBox from '../components/ui/FeatureBox';
import CTASection from '../components/ui/CTASection';
import { servicesContent } from '../content/services';
import './Services.css';

const Services = () => {
  return (
    <>
      <Helmet>
        <title>خدماتنا - نمو ماركتينج</title>
        <meta
          name="description"
          content="حلول رقمية متكاملة تساعدك على النمو: تصميم المواقع، إدارة السوشيال ميديا، والإعلانات الممولة"
        />
      </Helmet>

      <div className="services-page">
        {/* Hero Section */}
        <section className="page-hero">
          <div className="container">
            <div className="page-hero-content">
              <h1 className="page-hero-title">{servicesContent.hero.title}</h1>
              <p className="page-hero-subtitle">{servicesContent.hero.subtitle}</p>
              <p className="page-hero-description">{servicesContent.hero.description}</p>
            </div>
          </div>
        </section>

        {/* Main Services */}
        <section className="section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{servicesContent.mainServices.title}</h2>
              <p className="section-subtitle">{servicesContent.mainServices.subtitle}</p>
            </div>
            <div className="services-grid">
              {servicesContent.mainServices.services.map((service) => {
                const ServiceIcon = service.icon;
                return (
                  <div key={service.id} className="service-detail-card">
                    <div className="service-detail-icon">
                      <ServiceIcon />
                    </div>
                    <h3 className="service-detail-title">{service.title}</h3>
                    <p className="service-detail-description">{service.description}</p>
                    <ul className="service-detail-features">
                      {service.features.map((feature, index) => (
                        <li key={index}>
                          <span className="feature-check">✓</span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <Link to={service.link} className="btn btn-primary">
                      {service.buttonText}
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="section bg-light">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">{servicesContent.whyChooseUs.title}</h2>
              <p className="section-subtitle">{servicesContent.whyChooseUs.subtitle}</p>
            </div>
            <div className="grid grid-4">
              {servicesContent.whyChooseUs.features.map((feature) => (
                <FeatureBox
                  key={feature.id}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="section bg-primary">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title" style={{ color: 'var(--white)' }}>
                {servicesContent.stats.title}
              </h2>
              <p className="section-subtitle" style={{ color: 'var(--gray-100)' }}>
                {servicesContent.stats.subtitle}
              </p>
            </div>
            <div className="stats-grid">
              {servicesContent.stats.items.map((stat) => {
                const StatIcon = stat.icon;
                return (
                  <div key={stat.id} className="stat-box">
                    <div className="stat-icon">
                      <StatIcon />
                    </div>
                    <div className="stat-number">{stat.number}</div>
                    <div className="stat-label">{stat.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <CTASection
          title={servicesContent.cta.title}
          subtitle={servicesContent.cta.subtitle}
          buttonText={servicesContent.cta.buttonText}
          backgroundStyle="gradient"
        />
      </div>
    </>
  );
};

export default Services;
